import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import ApexCharts from 'apexcharts';

@Component({
    selector: 'bar-chart',
    templateUrl: './bar-chart.component.html',
    styleUrls: ['./bar-chart.component.scss'],
    standalone: false
})

export class BarChartComponent implements OnInit, OnDestroy {
  @Input() series;
  @Input() categories;
  options: any = {
    series: [{
      name: 'Total clicks',
      data: []
    }],
    colors: ['#0ca4e1', '#ac3c8a'],
    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
      colors: ['#000000'],
      foreColor: '#000000',
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 0,
            style: {
              fontSize: '13px',
              fontWeight: 900,
              foreColor: '#000000',
              colors: ['#000000']
            }
          }
        }
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ['#000000']
      }
    },
    xaxis: {
      categories: [],
      labels: {
        formatter: function (val) {
          return val;
        }
      }
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      offsetX: 40
    }
  };

  chart;

  constructor() {
  }

  ngOnInit() {
    this.renderChart();
  }

  renderChart() {
    const colors = [];
    if (this.series && this.categories) {
      if (this.chart?.destroy) {
        this.chart.destroy();
      }
      for (const type of this.series) {
        switch (type.name) {
          case 'touch2015':
            type.name = 'Touchboard';
            colors.push('#065170');
            break;
          case 'ibextouch':
            colors.push('#0ca4e1');
            break;
          case 'touch2go':
            type.name = 'Web App';
            colors.push('#561d45');
            break;
          case 'ibexsmart':
            colors.push('#ac3c8a');
            break;
          case 'ibextablet':
            colors.push('#EA522E');
            break;
          case 'ibextv':
            colors.push('#6AA799');
            break;
          case 'tweebieWeb':
            type.name = 'tweebie Web App';
            colors.push('#D11F1D');
            break;
          case 'app':
            type.name = 'tweebie Native App';
            colors.push('#B34844');
            break;
        }
        this.options.colors = colors;
      }
    }
    this.options.series = this.series;
    this.options.xaxis.categories = this.categories;
    this.chart = new ApexCharts(document.querySelector('#bar-chart'), this.options);
    this.chart.render()
  }

  ngOnDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
}
